import {
  LinkStandardSettings,
  ButtonLinkStandardSettings,
} from 'apps/studio/components/settings/fields/Link/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Link/advanced'

export const LinkSettings = [
  FieldSettingsPanel(LinkStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]

export const ButtonLinkSettings = [
  FieldSettingsPanel(ButtonLinkStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
